import { fadeIn } from '@hellodarwin/core/lib/theme/keyframes';
import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import Layout from 'antd/es/layout';
import Typography from 'antd/es/typography';
import styled from 'styled-components';
import { PreviewContent } from '../../../data/steps-content';

const { Header, Content } = Layout;
const { Title } = Typography;

export const StyledLayout = styled(Layout)`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledHeader = styled(Header)`
  background: ${({ theme }) => theme.colors.white_1};
  height: ${({ theme }) => theme.appearance.appHeaderHeight}px;
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
  z-index: 10;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey_4};
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  overflow: hidden;

  > *:first-child {
    grid-column: 2;
    justify-self: center;
    align-self: center;
  }

  > *:nth-child(2) {
    grid-column: 3;
    justify-self: flex-end;
    align-self: center;
  }
`;

export const StyledContent = styled(Content)`
  flex: 1;
  z-index: 1;
  position: relative;
  height: 100%;
  width: 100%;
`;

export const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.beige_2};
  align-items: center;
  justify-content: center;
  position: relative;

  ${media.l`
    flex-direction: column-reverse;
    align-items: flex-end;
    justify-content: flex-end;
    overflow: hidden;
    & > * {
      width: 100%;
      height: auto;
    }
  `}
`;

export const ContentBody = styled.div<{ $previewContent: PreviewContent }>`
  display: flex;
  flex-direction: row;
  overflow-y: auto;
  align-items: center;
  width: 100%;

  height: 100%;
  position: relative;
  & > * {
    width: 100%;
    height: 100%;
    flex-basis: ${({ $previewContent }) =>
      $previewContent === 'none' ? '100%' : '50%'};
    flex-shrink: 0;
    flex-grow: 0;
    overflow: hidden;
  }

  ${media.l`
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    overflow:auto;
    flex: 1;
    display: flex;

    padding-block: ${({ theme }) => theme.spacing.md}px;
    & > * {
     flex:none;
     flex-basis: auto;
     flex-shrink: 0;
     flex-grow: 0;
    }
   
  `}
`;

export const StyledTitle = styled(Title)`
  margin-bottom: 24px !important;
`;

export const OnboardingContentStyled = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  animation: ${fadeIn} 0.8s ease;

  overflow-y: auto;
  padding-inline: ${({ theme }) => theme.appearance.spacing * 6}px;
  padding-block: ${({ theme }) => theme.appearance.spacing * 8}px;

  ${media.l`
    padding-block: ${({ theme }) => theme.appearance.spacing * 2}px;
    padding-block-start: ${({ theme }) => theme.appearance.spacing * 1.5}px;
  `};
`;
